<!--<template>-->

<!--</template>-->

<!--<script>-->
<!--    import { Line } from 'vue-chartjs'-->

<!--    export default {-->
<!--        name: "BarChartHorizontal",-->
<!--        -->
<!--        extends: Line,-->
<!--        props: ['chartdata', 'options'],-->
<!--        mounted () {-->
<!--            this.renderChart(this.chartdata, this.options)-->
<!--        }-->
<!--    }-->
<!--</script>-->

<!--<style scoped>-->

<!--</style>-->
<template>
  <v-card style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25)" class="d-flex flex-column">
    <v-layout pa-7 style="flex: 1">
      <v-flex class="d-flex align-center">
        <div style="width: 100%">
          <canvas id="MeSeStatusCanvas"></canvas>
        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
    import { Bar } from 'vue-chartjs'

    export default {
        name: "BarChartHorizontal",
        extends: Bar,
        props: ['title','year','chartdata', 'options', 'dataname','unit'],

        mounted() {

            Chart.defaults.global.legend.display = false;

            var MeSeContext = document.getElementById("MeSeStatusCanvas").getContext("2d");
            var MeSeData = {
                labels: this.chartdata,
                datasets: [
                    {
                        label: this.dataname,
                        backgroundColor: '#527281',
                        data: this.options,
                    }
                ]
            };

            new Chart(MeSeContext, {
                type: 'horizontalBar',
                data: MeSeData,
            });
        }
    }
</script>

<style scoped>

  .titleCard {
    background: #4F4F4F;
    color: #FFFFFF;
  }

</style>
